export var DeliveryType;
(function (DeliveryType) {
    DeliveryType["Email"] = "EMAIL";
    DeliveryType["Portal"] = "PORTAL";
    DeliveryType["EmailAndPortal"] = "EMAIL_AND_PORTAL";
})(DeliveryType || (DeliveryType = {}));
export const DeliveryTypeToLabelMap = {
    [DeliveryType.Email]: 'Email only',
    [DeliveryType.Portal]: 'Display in portal only',
    [DeliveryType.EmailAndPortal]: 'Email and display in portal',
};
export * as Api from './api';
//# sourceMappingURL=index.js.map